/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { MyButton } from "../../component/Component";
import { useInfoContext } from "../../../../context/info/InfoContext";
import { pushOneAbout } from "../../../../middlewares/sysNavigation/SysNavigation";

const editRoute = "/about/edit";

const Overview = () => {
  const [localAbout, setLocalAbout] = useState(null);
  const { about, fetchAbout } = useInfoContext();

  useEffect(() => {
    if (!about) fetchAbout();
    else setLocalAbout(about);
  }, [about]);

  return (
    <div className="h-full overflow-hidden rounded-b-xl bg-gradient-to-b from-gray-50 to-white">
      {/* Top bar */}
      <div className="sticky top-0 z-10 border-b bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 lg:px-6">
          <div>
            <h1 className="text-sm font-semibold text-gray-900 tracking-tight lg:text-base">
              About Overview
            </h1>
            <p className="mt-0.5 text-[11px] text-gray-500">
              Mission, Vision, Goals & Objectives at a glance
            </p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="mx-auto h-[calc(100%-64px)] max-w-7xl overflow-y-auto px-3 py-4 lg:px-6">
        <div className="rounded-xl border bg-white shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full table-auto text-left text-sm">
              <thead className="bg-gray-50/80 text-[11px] uppercase tracking-wide text-gray-600">
                <tr>
                  <th className="whitespace-nowrap px-4 py-3 font-semibold">Mission</th>
                  <th className="whitespace-nowrap px-4 py-3 font-semibold">Vision</th>
                  <th className="whitespace-nowrap px-4 py-3 font-semibold">Goals</th>
                  <th className="whitespace-nowrap px-4 py-3 font-semibold">Objectives</th>
                  <th className="px-4 py-3 text-center font-semibold">Action</th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {localAbout ? (
                  <tr
                    key={localAbout.about_us_id}
                    className="hover:bg-gray-50/60 transition-colors"
                  >
                    <td className="px-4 py-4 align-top">
                      <span className="inline-flex rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-200">
                        Our Mission
                      </span>
                    </td>
                    <td className="px-4 py-4 align-top">
                      <span className="inline-flex rounded-full bg-indigo-50 px-2 py-1 text-xs font-medium text-indigo-700 ring-1 ring-inset ring-indigo-200">
                        Our Vision
                      </span>
                    </td>
                    <td className="px-4 py-4 align-top">
                      <span className="inline-flex rounded-full bg-emerald-50 px-2 py-1 text-xs font-medium text-emerald-700 ring-1 ring-inset ring-emerald-200">
                        Our Goal
                      </span>
                    </td>
                    <td className="px-4 py-4 align-top">
                      <span className="inline-flex rounded-full bg-amber-50 px-2 py-1 text-xs font-medium text-amber-700 ring-1 ring-inset ring-amber-200">
                        Our Objectives
                      </span>
                    </td>
                    <td className="px-4 py-4 align-top">
                      <ActionButton props={localAbout} />
                    </td>
                  </tr>
                ) : (
                  <tr className="animate-pulse">
                    {Array.from({ length: 4 }).map((_, idx) => (
                      <td key={idx} className="px-4 py-4">
                        <div className="h-5 w-28 rounded-full bg-gray-200" />
                      </td>
                    ))}
                    <td className="px-4 py-4">
                      <div className="h-9 w-20 rounded-lg bg-gray-200" />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Subtle helper text */}
        <p className="mt-3 text-[11px] text-gray-500">
          Edit to update the content visible on your public "About" page.
        </p>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  return (
    <div className="flex items-center justify-center px-2 py-1">
      <Link to={editRoute}>
        <MyButton
          title="Edit"
          className="rounded-lg bg-blue-600 px-3 py-2 text-xs font-semibold shadow-sm ring-1 ring-inset ring-blue-500/0 transition hover:bg-blue-700 hover:shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          onClick={() => pushOneAbout(props)}
        />
      </Link>
    </div>
  );
};

export default Overview;
